exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-button--primary[data-v-5ee46b4d]{background:#2675F1;border-color:#2675F1}.num[data-v-5ee46b4d]{font-size:0.28rem;font-family:Roboto-Regular, Roboto;font-weight:400;color:#1F1F1F}.con p[data-v-5ee46b4d]:first-child{font-size:0.24rem;font-family:Roboto-Medium, Roboto;font-weight:500;color:#1F1F1F;line-height:0.28rem}.con p:first-child .el-icon-warning[data-v-5ee46b4d]{color:#FFA200}.con p[data-v-5ee46b4d]:last-child{font-size:0.2rem;font-family:Roboto-Regular, Roboto;font-weight:500;color:#1F1F1F;line-height:0.24rem;padding-left:0.3rem}\n", ""]);

// exports
